export const MIN_AUDIO_RECORDING_BYTES = 256;
export const MIN_AUDIO_RECORDING_DURATION_MS = 500;

export const getAudioRecordingError = (size: number, durationMs?: number): string | null => {
    const isTooShort = durationMs !== undefined && durationMs < MIN_AUDIO_RECORDING_DURATION_MS;

    if (size < MIN_AUDIO_RECORDING_BYTES || isTooShort) {
        return 'Запись слишком короткая. Удерживайте кнопку микрофона во время записи.';
    }

    return null;
};

export const getAudioFilenameExtension = (mimetype: string): 'webm' | 'ogg' => (
    mimetype.includes('webm') ? 'webm' : 'ogg'
);
